import { render, staticRenderFns } from "./veStuMoralActiveAdmin.vue?vue&type=template&id=67415ffc&scoped=true"
import script from "./veStuMoralActiveAdmin.vue?vue&type=script&lang=js"
export * from "./veStuMoralActiveAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67415ffc",
  null
  
)

export default component.exports